import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "onBlur", "currencySymbol", "currencyCode"];
import React from "react";
import TextInput from "../TextInput";
import { format } from "./logic";
import { jsx as _jsx } from "react/jsx-runtime";
var CurrencyInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var value = _ref.value,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? function () {
      return null;
    } : _ref$onBlur,
    _ref$currencySymbol = _ref.currencySymbol,
    currencySymbol = _ref$currencySymbol === void 0 ? "$" : _ref$currencySymbol,
    currencyCode = _ref.currencyCode,
    props = _objectWithoutProperties(_ref, _excluded);
  var formattedValue = format(value);
  var handleBlur = function handleBlur(e) {
    e.target.value = formattedValue;
    onBlur(e);
  };
  return /*#__PURE__*/_jsx(TextInput, _extends({
    value: value
  }, props, {
    type: "text",
    inputMode: "decimal",
    placeholder: "0.00",
    adornStart: {
      type: "text",
      props: {
        text: currencySymbol
      }
    },
    adornEnd: {
      type: "text",
      props: {
        text: currencyCode
      }
    },
    onBlur: handleBlur,
    ref: ref
  }));
});
CurrencyInput.displayName = "CurrencyInput";
export default CurrencyInput;